export default "__VITE_ASSET__Bfdw0C7P__"